import { useEffect, useRef } from 'react';

/**
 * On mount the table reports its URL filters and an opened search restores its
 * saved filter tree. Both arrive before the first search returns, so changes
 * before then are restores, and a reset would drop the page the recruiter came
 * back to.
 *
 * Filters are compared by content: the filter state builds a new object on
 * every update, including updates that change nothing.
 */
export const useResetPageOnFiltersChange = (
  filters: unknown,
  isSearchLoading: boolean,
  resetPage: () => void
): void => {
  const filtersKey = JSON.stringify(filters ?? null);
  const previousFiltersKeyRef = useRef(filtersKey);
  const hasLoadedRef = useRef(false);

  // Runs before the effect below, so a change in the same render as the first
  // result still counts as a restore.
  useEffect(() => {
    const previousFiltersKey = previousFiltersKeyRef.current;
    previousFiltersKeyRef.current = filtersKey;

    if (hasLoadedRef.current && previousFiltersKey !== filtersKey) {
      resetPage();
    }
  }, [filtersKey]);

  useEffect(() => {
    if (!isSearchLoading) {
      hasLoadedRef.current = true;
    }
  }, [isSearchLoading]);
};
